import React, { ReactElement, useMemo } from "react";
import { fundContext } from "../../../../hooks/datatabs";
import AuditTrail from "../../../../components/audittrail/audittrail";

function FundAuditTrail(): ReactElement {
  const data = fundContext();
  const entityId = useMemo(() => data?._id || null, [data?._id]);

  return (
    <>
      { data?._id && entityId &&
        <AuditTrail entityType='fund' id={entityId || ''} />
      }
    </>
  );
}

export default FundAuditTrail;